import List from './views/List.vue'

export const ProcessedPayrollsRoutes = [
  {
    path: '/processed-payrolls',
    name: 'ListProcessedPayrolls',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll_processed:list'
    }
  }
]
